<template>
  <list-layout>
    <template slot="filterItem">
      <search-item label="赠送类型">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
      <search-item label="会员ID">
        <el-input></el-input>
      </search-item>
    </template>
    <template slot="filterBtn">
      <el-button @click="showSearchBarHandle">qiehuan</el-button>
    </template>
  </list-layout>
</template>

<script>
import searchMixin from '@/mixins/searchBar';

export default {
  name: 'Demo',
  mixins: [searchMixin],
};
</script>
